import { route } from 'ziggy';

export const dockCategories = ['teammates', 'actions', 'links', 'tools'];

export const dockCategoryLabels = {
    teammates: 'navigation:dock.category.teammates',
    actions: 'navigation:dock.category.actions',
    links: 'navigation:dock.category.links',
    tools: 'navigation:dock.category.tools',
};

export const maxDockSlots = 8;

// Registry returned by a function so route() resolves at call time, not module init.
// Add new shortcuts here. To retire one, just remove the entry — saved user prefs
// referencing it will be dropped automatically on next load (see filterValidKeys).
export function getAvailableDockActions() {
    return [
        // Teammates
        { key: 'teammate-stella', label: 'navigation:teammates.paige', icon: 'fa-paintbrush', href: '/webpage-pages/create?title=Home&ai_page=1', category: 'teammates' },
        { key: 'teammate-tom', label: 'navigation:teammates.buddy', icon: 'fa-handshake', href: '/bo/tom', category: 'teammates' },
        { key: 'teammate-maya', label: 'navigation:teammates.spark', icon: 'fa-pen-fancy', href: '/bo/ai-content-creator', category: 'teammates' },
        { key: 'teammate-oscar', label: 'navigation:teammates.scout', icon: 'fa-binoculars', href: '/bo/hugo', category: 'teammates' },
        { key: 'teammate-susan', label: 'navigation:teammates.pulse', icon: 'fa-chart-mixed', href: '/bo/susan', category: 'teammates' },
        { key: 'teammate-alex', label: 'navigation:teammates.reach', icon: 'fa-envelope-open-text', href: '/bo/alex', category: 'teammates' },
        { key: 'teammate-leo', label: 'navigation:teammates.loop', icon: 'fa-arrows-spin', href: '/bo/leo', category: 'teammates' },

        // Quick actions
        { key: 'add-contact', label: 'navigation:dock.addContact', icon: 'fa-user-plus', action: 'slideout:toolbar-add-lead', category: 'actions' },
        { key: 'new-page', label: 'navigation:dock.newPage', icon: 'fa-file-plus', href: '/webpage-pages/create', category: 'actions' },
        { key: 'new-newsletter', label: 'navigation:dock.newNewsletter', icon: 'fa-envelope-circle-check', href: '/bo/newsletters/create', category: 'actions' },

        // Links — feature destinations
        // { key: 'link-contacts', label: 'navigation:dock.linkContacts', icon: 'fa-address-book', href: '/bo/crm/contacts', category: 'links' },
        // { key: 'link-newsletters', label: 'navigation:dock.linkNewsletters', icon: 'fa-envelope', href: '/bo/newsletters', category: 'links' },
        // { key: 'link-orders', label: 'navigation:dock.linkOrders', icon: 'fa-receipt', href: '/bo/orders', category: 'links' },
        // { key: 'link-pages', label: 'navigation:dock.linkPages', icon: 'fa-file', href: '/webpage-pages', category: 'links' },

        // Tools
        { key: 'url-shortener', label: 'navigation:dock.urlShortener', icon: 'fa-link', action: 'tool:url-shortener', category: 'tools' },
        { key: 'password-gen', label: 'navigation:dock.passwordGenerator', icon: 'fa-key', action: 'tool:password-generator', category: 'tools' },
        { key: 'qr-gen', label: 'navigation:dock.qrGenerator', icon: 'fa-qrcode', action: 'tool:qr-generator', category: 'tools' },
        { key: 'time-tracking', label: 'navigation:dock.timeTracking', icon: 'fa-clock', action: 'tool:time-tracking', category: 'tools' },
        { key: 'media-upload', label: 'navigation:dock.mediaUpload', icon: 'fa-upload', action: 'tool:media-upload', category: 'tools' },
        { key: 'tasks', label: 'navigation:dock.tasks', icon: 'fa-list-check', action: 'tool:tasks', category: 'tools' },
    ];
}

export function getActionByKey(key) {
    return getAvailableDockActions().find(a => a.key === key) || null;
}

// Drops keys that no longer exist in the registry. Use the returned `changed`
// flag to decide whether to persist the cleaned list back to user prefs.
export function filterValidKeys(keys) {
    const registry = getAvailableDockActions();
    const valid = keys.filter(key => registry.some(a => a.key === key));
    return { keys: valid, changed: valid.length !== keys.length };
}

export function serializeKeys(keys) {
    return keys.join(',');
}

export function parseKeys(raw) {
    if (!raw || typeof raw !== 'string') return [];
    return raw.split(',').map(k => k.trim()).filter(Boolean);
}
